import mara from "@/data/btc-production/mara.js";
import riot from "@/data/btc-production/riot.js";
import hut8 from "@/data/btc-production/hut8.js";
import bitf from "@/data/btc-production/bitf.js";
import hive from "@/data/btc-production/hive.js";
import argo from "@/data/btc-production/argo.js";
import btbt from "@/data/btc-production/btbt.js";
import hsshf from "@/data/btc-production/hsshf.js";

export default [
  { name: "mara", stats: mara },
  { name: "riot", stats: riot },
  { name: "hut8", stats: hut8 },
  { name: "bitf", stats: bitf },
  { name: "hive", stats: hive },
  { name: "argo", stats: argo },
  { name: "btbt", stats: btbt },
  { name: "hsshf", stats: hsshf },
]
